<template>
  <div class="pz-parent" style="height: 920px;">
    <!-- <drag-select
      ref="dragSelect"
      @stopDragSelecting="stopDragSelect"
      @updateSelected="selectedCardRefs = $event"
      selectionBoxStyling="z-index: 1;"
      :selectableRefs="$refs.cards"
    ></drag-select> -->
    <div ref="canvas" class="pz-canvas" @mousedown.left.self.exact="startDragSelect">
      <draggable-card
        v-for="(card, index) in cardItems"
        ref="cards"
        @mousedown.left.stop="pz.pause()"
        @hoverStart="pz.pause()"
        @hoverEnd="pz.resume()"
        :pz="pz"
        :card="card"
        :pos="cardPositions[card.id] || { id: card.id, x: 0, y: 200 * index + 20 }"
        :key="card.id"
        :class="draggingCardId === card.id ? 'blue' : null"
        :selected="!!selectedCardRefs.find(s => s.card.id == card.id)"
        :draggingCardId="draggingCardId"
        @dragStart="
          pz.pause();
          draggingCardId = card.id;
        "
        @dragEnd="
          pz.resume();
          draggingCardId = false;
        "
        @updatePosition="updateCardPositions($event)"
      ></draggable-card>
      <!-- <selection-menu
        v-if="selectedCardRefs.length > 1"
        :style="
          `left:${selectionBound.x - 5}px; width: ${selectionBound.width +
            10}px; top: ${selectionBound.y - 5}px; height: ${selectionBound.height + 10}px;`
        "
        @makeGroup="makeSelectionGroup"
      ></selection-menu> -->
    </div>
  </div>
</template>

<script>
import DraggableCard from './DraggableCard';
import DragSelect from './DragSelect.vue';
// import SelectionMenu from './SelectionMenu';
import panzoom from 'panzoom';

import { pagesModule } from '@/store/database/pagesModule';
import { computed, ref } from '@vue/composition-api';

export default {
  components: {
    DraggableCard,
    DragSelect
    // SelectionMenu
  },
  props: ['pageId'],
  setup(props) {
    const cardItems = computed({
      get() {
        const page = pagesModule.doc(props.pageId).data;
        return Object.values(page.pageNotes)
          .filter(p => !p.toDelete && p.id != undefined)
          .sort((a, b) => (a.order > b.order ? 1 : -1));
      },
      set(v) {
        console.log('set computed', v);
      }
    });

    const cardPositions = ref({});
    return {
      cardItems,
      cardPositions
    };
  },
  data() {
    return {
      pz: null,
      selectedCardRefs: [],
      draggingCardId: false,
      spaced: false,
      newCard: { x: 0, y: 0 }
    };
  },
  computed: {
    // selectionBound() {
    //   let bound = { x: 0, y: 0, w: 0, h: 0 };
    //   if (this.selectedCardRefs.length) {
    //     let lefts = [],
    //       tops = [],
    //       rights = [],
    //       bottoms = [];
    //     this.selectedCardRefs.forEach(c => {
    //       lefts.push(c.value.x);
    //       tops.push(c.value.y);
    //       rights.push(c.value.x + c.$el.clientWidth);
    //       bottoms.push(c.value.y + c.$el.clientHeight);
    //     });
    //     console.log(lefts);
    //     bound = {
    //       x: Math.min(...lefts),
    //       y: Math.min(...tops),
    //       width: Math.max(...rights) - Math.min(...lefts),
    //       height: Math.max(...bottoms) - Math.min(...tops)
    //     };
    //   }
    //   console.log(bound);
    //   return bound;
    // }
  },
  mounted() {
    const el = this.$refs.canvas;
    this.pz = panzoom(el, {
      smoothScroll: false,
      zoomDoubleClickSpeed: 1,
      filterKey: function(/* e, dx, dy, dz */) {
        // don't let panzoom handle this event:
        return true;
      },
      onDoubleClick: function(e) {
        // `e` - is current double click event.
        return false; // tells the library to not preventDefault, and not stop propagation
      }
    });
    document.addEventListener('keydown', this.handleSpace);
    document.addEventListener('keyup', this.handleSpaceUp);
    document.addEventListener('keydown', this.handleDeleteSelectedCards);
  },
  beforeDestroy() {
    this.pz.document.removeEventListener('keydown', this.handleSpace);
    document.removeEventListener('keyup', this.handleSpaceUp);
  },
  methods: {
    handleSpace(e) {
      if (e.keyCode == 32) {
        this.spaced = true;
      }
    },
    handleSpaceUp(e) {
      if (e.keyCode == 32) {
        this.spaced = false;
      }
    },
    startDragSelect(e) {
      if (this.spaced) {
        return;
      }
      console.log('drag');
      // this.pz.pause();
      // this.$refs.dragSelect.onMouseDown(e);
    },
    stopDragSelect() {
      console.log('stop');
      this.pz.resume();
    },
    // handleDeleteSelectedCards(e) {
    //   console.log(e);
    //   if (e.keyCode == 46) {
    //     console.log('delete');
    //     const cardIds = this.selectedCardRefs.map(q => q.value.id);
    //     cardIds.forEach(id => {
    //       const index = this.cards.findIndex(q => q.id == id);
    //       this.$delete(this.cards, index);
    //     });
    //     this.selectedCardRefs = [];
    //   }
    // },
    updateCardPositions(event) {
      const { id, x, y } = event; //event
      let result = {};
      const movedCard = this.cardItems.find(q => q.id == id);
      if (this.selectedCardRefs.find(q => q.value.id == id)) {
        // the dragged card is a selected card
        this.selectedCardRefs.forEach(card => {
          const diffX = card.value.x - movedCard.x;
          const diffY = card.value.y - movedCard.y;
          result[card.value.id] = { id: card.value.id, x: x + diffX, y: y + diffY };
          // result.push({ id: card.value.id, x: x + diffX, y: y + diffY });
          console.log(diffX, diffY);
        });
      } else {
        result[id] = event;
      }
      this.cardPositions = { ...this.cardPositions, ...result };
      // this.$emit('updatePosition', result);
    }
  }
};
</script>

<style>
.pz-parent {
  position: absolute;
  top: 38px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: #eee;
  touch-action: none;
  overflow: hidden;
}
.pz-canvas {
  position: absolute;
  width: 5000px;
  height: 3000px !important;
  background-repeat: repeat;
  background-color: white;
  backface-visibility: inherit !important;
  background-image: -webkit-linear-gradient(
      0deg,
      transparent 0.05em,
      rgba(0, 0, 0, 0.0470588) 0.05em,
      rgba(0, 0, 0, 0.0470588) 0.125em,
      transparent 0.125em
    ),
    -webkit-linear-gradient(top, rgba(0, 0, 0, 0.0470588) 0.0625em, transparent 0.0625em);
  background-size: 0.75em 0.75em;
  background-position: 0px -0.5em;
}
</style>
